import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressButtonComponent } from './progressbutton.component';
import { ProgressButtonModule } from './progressbutton.module';
/**
 * NgModule definition for the ProgressButton component with providers.
 */
export class ProgressButtonAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ProgressButtonModule],
    exports: [
        ProgressButtonModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProgressButtonAllModule_tsickle_Closure_declarations() {
/** @type {?} */
ProgressButtonAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProgressButtonAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
